import { createBrowserRouter } from "react-router-dom";
import Login from "@/pages/auth/login";
import ChallengeList from "@/pages/challenge/list";
import DynamicPage from "@/pages/dynamic-page";
import Ranking from "@/pages/ranking";
import Rewards from "@/pages/rewards";

import Register from "@/pages/auth/register";

const router = createBrowserRouter([
  {
    path: "/",
    element: <DynamicPage />,
  },
  {
    path: "/challenges",
    element: <ChallengeList />,
  },
  {
    path: "/ranking",
    element: <Ranking />,
  },
  {
    path: "/rewards",
    element: <Rewards />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "*",
    element: <DynamicPage />,
  },
]);

export default router;
